import React from 'react';
import ReactDOM from 'react-dom';
import ActionButton from 'ub/ui/canvas/action-button';

const _isInlineTextElement = (elm) =>
  (elm.type === 'lp-pom-text') &&
  elm.inEditMode;

const _buildProps = (elm) => {
  const paddingBetweenElements = 8;
  const linksToInternalLightbox = elm.model.linksToInternalLightbox();

  const props = {
    elmType: elm.type,
    topOffset: elm.view.getHeight() + paddingBetweenElements,
    linksToInternalLightbox
  };

  if (_isInlineTextElement(elm)) {
    props.label = '</> View Source';
  } else if (elm.type === 'lp-pom-button' && linksToInternalLightbox) {
    props.label = 'Edit Lightbox';
  }

  return props;
};

const ActionMenu = (parentElm) => {
  const render = (options) => {
    const props = _buildProps(options.elm);

    const isValidActionButtonType = _isInlineTextElement(options.elm) ||
      (props.elmType === 'lp-pom-button' && props.linksToInternalLightbox);

    ReactDOM.render(
      <div>
        {isValidActionButtonType ?
          <ActionButton
            topOffset={props.topOffset}
            clickAction={options.clickAction}
            label={props.label}
          /> : null
        }
      </div>,
      parentElm
    );
  };

  return {
    render
  };
};

export default ActionMenu;



// WEBPACK FOOTER //
// ./src/ui/canvas/action-menu.jsx